package diana.soleil.design.iraniancanadienbazzar.core.model

/** A user the caller has blocked (`users/{uid}/blockedUsers/{targetUid}`); [name] is a snapshot. */
data class BlockedUser(
    val uid: String,
    val name: String,
)
